import { Typography } from "@lyfegen-platform/react-common";
import { Accordion, AccordionDetails, AccordionSummary, Box, Collapse, Divider, useTheme } from "@material-ui/core";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { Fragment, useState } from "react";
import { CaseStatus } from "../../../models/generated/graphql";
import useStyles from "../use-styles";
import { MainCaseInformationDetails } from "./CaseInformationDetails";
import { IAttribute } from "./Overview";

interface CaseInformationProps {
	title: string;
	children: React.ReactChild | React.ReactChildren;
	patientAttributes: IAttribute[] | undefined;
	status?: CaseStatus;
}

const CaseInformation = (props: CaseInformationProps) => {
	const [isExpanded, setIsExpanded] = useState(props.status !== CaseStatus.InReview);
	const { bodyItemHeaderTop, collapseTitle } = useStyles();
	const { palette } = useTheme();

	function handleChange() {
		setIsExpanded(!isExpanded);
	}

	return (
		<Fragment>
			<Accordion
				expanded={true}
				defaultExpanded
				onChange={handleChange}
				TransitionProps={{ unmountOnExit: true }}
				style={{ borderRadius: "4px 4px 0px 0px" }}
				elevation={0}
			>
				<AccordionSummary
					className={bodyItemHeaderTop}
					style={{ display: "flex", flexDirection: "row-reverse" }}
					expandIcon={isExpanded ? <ExpandMoreIcon color={"inherit"} /> : <ExpandLessIcon color={"inherit"} />}
					aria-controls={props.title}
					id={props.title}
				>
					<Typography className={collapseTitle} type={"h5"} color={"textSecondary"}>
						{props.title}
					</Typography>
				</AccordionSummary>
				<Box justifyContent="space-between" width="100%" display="flex" alignItems="center" pb={2}>
					<Divider style={{ flexGrow: 1, backgroundColor: palette.tableDivider.main }} />
				</Box>
				<AccordionDetails>
					<Box display="flex" width="100%" flexDirection="column" px={4}>
						{props.patientAttributes?.length ? (
							<MainCaseInformationDetails patientAttributes={props.patientAttributes} />
						) : (
							<></>
						)}
						<Collapse in={isExpanded}>{props.children}</Collapse>
					</Box>
				</AccordionDetails>
			</Accordion>
		</Fragment>
	);
};

export default CaseInformation;
